// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3b0d7fae","239":"09ada442","453":"ce902b9e","455":"a0378bd7"}[chunkId] + ".chunk.js";
};